export default __webpack_public_path__ + "static/media/Google__G__Logo.svg.bb49f97a.png";